import { Divider, MenuItem, Stack, Typography } from '@mui/material';
import {
    gridPageCountSelector,
    gridPageSizeSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
} from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { StyledPagination } from './grid.styles';
import { StyledDropdown } from './grid.styles';

export const GridPagination = ({ paginationIconBgColor, paginationIconColor, rowsPerPageOptions }: { paginationIconBgColor: string; paginationIconColor: string, rowsPerPageOptions?: number[] }) => {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    const pagenumber = useMemo(() => pageCount < 1 ? page : page + 1, [pageCount, page]);
    const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

    return (
        <Stack spacing={2} direction={'row'}>
            {rowsPerPageOptions && rowsPerPageOptions.length > 1 && 
                <>
                    <StyledDropdown
                        value={pageSize}
                        onChange={(event) => apiRef.current.setPageSize(Number((event.target as HTMLInputElement).value))}
                    >
                        {rowsPerPageOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </StyledDropdown>
                    <Divider flexItem orientation="vertical" />
                </>
            }
            <Typography variant='subtitle2'>Page: {pagenumber} of {pageCount}</Typography>
            <Divider flexItem orientation="vertical" />
            <StyledPagination
                showFirstButton
                showLastButton
                size='small'
                paginationIconBgColor={paginationIconBgColor}
                paginationIconColor={paginationIconColor}
                count={pageCount}
                page={pagenumber}
                onChange={(_event, value) => apiRef.current.setPage(value - 1)}
            />
        </Stack>
    );
};

